
import { PurchaseFilterActions, PurchaseFilterActionTypes } from '../actions/purchase-filter.actions';

export interface State {
  ItemType: number;
}

export const initialState: State = {
  ItemType: -1
};

export function reducer(state = initialState, action: PurchaseFilterActions): State {
  switch (action.type) {
    case PurchaseFilterActionTypes.LoadPurchaseFilters:
      return {...state, ItemType: action.payload.ItemType};

    default:
      return state;
  }
}
